"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import $ from "jquery";
import _ from "underscore";
import "./factor_invoices_service";
class FactorInvoiceUpdateServiceClass {
  constructor() {
    __publicField(this, "logging");
    __publicField(this, "ready");
    __publicField(this, "pingFrequency");
    __publicField(this, "timeoutInterval");
    __publicField(this, "channel");
    this.logging = true;
    this.ready = true;
    this.pingFrequency = 1e3 * 60;
    this.timeoutInterval = 1e3 * 60 * 3;
  }
  listenForGeocodeUpdates(pusher, emailId) {
    var channelName = "email-message-" + emailId + "-updates";
    if (pusher.channel(channelName)) {
      this.channel = pusher.channel(channelName);
    } else {
      this.unsubscribeFromAllChannels(pusher);
      this.channel = pusher.subscribe(channelName);
    }
    this.channel.bind(
      "client-hubtran:geocoding_updated",
      this.triggerInvoiceUpdated
    );
  }
  unsubscribeFromAllChannels(pusher) {
    const channelNames = _.keys(pusher.channels.channels);
    _.each(channelNames, function(channel) {
      pusher.unsubscribe(channel);
    });
  }
  triggerInvoiceUpdated() {
    $(this).trigger("FactorInvoiceUpdateService:invoiceUpdated");
  }
}
var FactorInvoiceUpdateService = new FactorInvoiceUpdateServiceClass();
export default FactorInvoiceUpdateService;
